<template>
  <table :class="['product-rows', { 'product-rows--use-multiselect': mq('to-medium') && (rows !== undefined && rows.length > 0 )}]">
    <thead>
      <tr>
        <th class="product-row__head-remove">
          <div class="product-row__head-inset">
            <oie-base-checkbox v-model="selectAll" is-for="order-history-select-all" :text="mq('to-medium') ? tStatic('cartProductHeaderSelectAllLabel') : null"></oie-base-checkbox>
          </div>
        </th>

        <th class="product-row__head-image"></th>

        <th class="product-row__head-article-name">
          <div v-epi-edit="'articleNameHeader'" class="product-row__head-inset">
            <span>
              {{ t('articleNameHeader') }}
              <!-- Artikelnamn -->
            </span>
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'articleDeliveredCountHeader'" class="product-row__head-inset">
            {{ t('articleDeliveredCountHeader') }}
          </div>
        </th>

        <th class="product-row__head-comment">
          <div v-epi-edit="'rowCommentHeader'" class="product-row__head-inset">
            {{ t('rowCommentHeader') }}
            <!-- Kommentar -->
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, key) in rows" :key="`table-row-${key}`">
        <td class="product-row__body-td--checkbox">
          <div class="product-row__body-inset product-row__body-inset--select">
            <validation-provider
              :rules="{ required: value => value.length > 0 }"
              slim>
              <template slot-scope="{ errors }">
                <oie-base-checkbox
                  v-model="selectedRows"
                  :val="row"
                  size="medium"
                  :is-for="`history-details-product-${key}`"
                  :errors="errors"></oie-base-checkbox>
                <span v-if="errors.length" class="error">{{ t('selectAtLeastOneRowValidationMessage') }}</span>
              </template>
            </validation-provider>
          </div>
        </td>

        <td class="product-row__body-td--image">
          <div class="product-row__body-inset">
            <oie-base-image
              :images="row.imageUrl ? getAssetPath(`${row.imageUrl}?preset=ProductSmall&watermark=OIEWatermarkSmall`) : getAssetPath('/globalassets/missing404/404.png?preset=ProductSmall')"
              :alt-text="row.artName"
              image-width="3.75rem"
              image-height="3.75rem"
              class="product-row__image"></oie-base-image>
          </div>
        </td>

        <td class="product-row__body-td--article">
          <div class="product-row__body-inset product-row__body-inset--article">
            <a :href="row.url" class="product-row__name">
              {{ row.artName }}

              <div class="product-row__article-number">
                {{ t('articleNumberLabel') }} {{ row.artNr }}
              </div>
            </a>
          </div>
          <!--
          <div class="product-row__body-inset product-row__body-inset--article">
            <div class="product-row__article-number">
              {{ t('articleNumberLabel') }} {{ row.artNr }}
            </div>
          </div>
            -->
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('articleDeliveredCountHeader') }}
          </div>

          <div class="product-row__body-inset">
            <!-- {{ row.deliveredQuantity }} -->
            <oie-order-return-product-quantity v-model="row.quantity" :cart-row="row"></oie-order-return-product-quantity>
          </div>
        </td>

        <td class="product-row__td--comment">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowCommentHeader') }}
          </div>

          <div class="product-row__body-inset">
            <validation-provider
              v-if="row.isVisible"
              :name="`return-reason-${key}`"
              rules="required"
              slim>
              <template slot-scope="{ errors }">
                <oie-base-dropdown
                  v-show="row.isVisible"
                  v-model="row.returnReasonId"
                  :initial-text="tStatic('orderReturnReasonDropdownText')"
                  :options="orderReturnReasonOptions"
                  :is-large="false"
                  :is-for="`history-details-product-${key}`"
                  :value="row"
                  :block-id="`history-details-product-${key}`"
                  :use-full-width="true"
                  :use-thin-border="true"
                  :error-message="errors[0]"></oie-base-dropdown>
              </template>
            </validation-provider>

            <validation-provider
              v-if="row.isVisible"
              :name="`return-reason-description-${key}`"
              :rules="row.returnReasonId !== 1 ? 'required' : ''"
              slim>
              <template slot-scope="{ errors }">
                <oie-base-input
                  v-show="row.isVisible && row.returnReasonId"
                  :id="`return-reason-description-${key}`"
                  :key="`return-reason-description-${key}`"
                  v-model="row.returnReasonDescription"
                  :textarea="true"
                  :max-length="2000"
                  :placeholder="getReturnReasonDescriptionPlaceholder(row.returnReasonId)"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <validation-provider
              v-if="row.isVisible"
              :name="`machine-type-${key}`"
              :rules="row.returnReasonId !== 1 && row.returnReasonId !== 2 && row.returnReasonId !== 6 ? 'required' : ''"
              slim>
              <template slot-scope="{ errors }">
                <oie-base-input
                  v-show="row.isVisible && (row.returnReasonId === 3 || row.returnReasonId === 4 || row.returnReasonId === 5)"
                  :id="`machine-type-${key}`"
                  :key="`machine-type-${key}`"
                  v-model="row.machineName"
                  :placeholder="tStatic('orderReturnMachineTypePlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <validation-provider
              v-if="row.isVisible"
              :name="`serial-number-${key}`"
              :rules="row.returnReasonId !== 1 && row.returnReasonId !== 2 && row.returnReasonId !== 6? 'required' : ''"
              slim>
              <template slot-scope="{ errors }">
                <oie-base-input
                  v-show="row.isVisible && (row.returnReasonId === 3 || row.returnReasonId === 4 || row.returnReasonId === 5)"
                  :id="`serial-number-${key}`"
                  :key="`serial-number-${key}`"
                  v-model="row.serialNumber"
                  :placeholder="tStatic('orderReturnSerialNumberPlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <!--
            <oie-order-return-file-upload
              :order-return="orderReturn"
              v-show="row.isVisible && (row.returnReasonId === 3 || row.returnReasonId === 4 || row.returnReasonId === 5 || row.returnReasonId === 6)"
              class="order-return-container__order-return-file-upload"></oie-order-return-file-upload>
              -->
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    orderReturn: {
      type: Object,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    returnsPossible: {
      type: Boolean,
      default: true
    },
    complaintReturnsPossible: {
      type: Boolean,
      default: true
    },
    isSuperUser: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedRows: [],
    unselectedRows: [],

    selectedOrderReturnReason: null,
    machineType: null

  }),
  computed: {
    selectAll: {
      get() {
        const unselectedRows = _.filter(this.rows, (row) => !_.includes(this.selectedRows, row))

        return this.selectedRows.length > 0 && unselectedRows.length === 0
      },
      set(value) {
        if (!value) {
          this.selectedRows = []
        } else {
          this.selectedRows = [...this.rows]
        }
      }
    },
    orderReturnReasonOptions() {
      let reasons = []

      if (this.returnsPossible || this.isSuperUser) {
        reasons.push({ text: this.t('orderReturnReasonDropdownOption1'), value: 1 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption2'), value: 2 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption3'), value: 3 })
      }

      if (this.complaintReturnsPossible || this.isSuperUser) {
        reasons.push({ text: this.t('orderReturnReasonDropdownOption5'), value: 5 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption6'), value: 6 })
      }

      return reasons
    }
  },
  watch: {
    selectedRows(selRows) {
      this.publish('order-return-rows-selection-updated', selRows)

      for (let i = 0; i < this.rows.length; i++) {
        this.rows[i].isVisible = false
      }

      for (let i2 = 0; i2 < selRows.length; i2++) {
        selRows[i2].isVisible = true
      }
    }
  },
  mounted() {
    this.subscribe('order-return-product-quantity-updated', row => {
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row)
      }
    })
  },
  methods: {
    getReturnReasonDescriptionPlaceholder(returnReasonId) {
      if (returnReasonId === 2) {
        return this.t('orderReturnNotReceivedWhatWasOrderedPlaceholder') // 'Beskriv felet, t.ex. vilket artikelnummer du fått istället'
      }

      return this.tStatic('orderReturnReasonDescriptionPlaceholder')
    }
  }
}
</script>
<style>
.order-return-container__order-return-file-upload {

  margin-top: 0.4rem;
}
</style>
